<script>
export default {
    name: "CashOutPrint",

    data() {

        return {
            cashOuts: []
        };
    },

    computed: {

        cashOutItems() {

            if(!this.cashOuts.length) return [];

            return this.cashOuts.map(item => {
                return {
                    id: item.id,
                    amount: item.amount,
                };
            });
        },

        total() {
            if(!this.cashOutItems.length) return 0;

            return this.cashOutItems.map(cItem => cItem.amount ? parseFloat(cItem.amount) : 0)
                .reduce((amt, accAmt) => amt+accAmt);
        },
    },

    mounted() {
        this.$root.loading=true;
        this.fetchCashOuts().then(response => {
                this.cashOuts = response.data;
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                }, 250);
            }).catch(() => { this.$root.loading=false; });
        
    },

    methods: {

        fetchCashOuts() {
            let url = `Accounts/GetPendingCashOut`;
                url += `?Datefrom=${this.$route.query.DateFrom}`;
                url += `&Dateto=${this.$route.query.DateTo}`;

            return this.$http.get(url);
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-1">
        <tail-address-header></tail-address-header>
        <table class="table mt-3">
            <thead class="text-sm">
                <tr>
                    <th class="p-tiny">ID</th>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Authorised By</th>
                    <th class="p-tiny">Received By</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Memo</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Username</th>
                    <th class="p-tiny">Amt</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(cashOut, idx) in cashOuts" :key="idx">
                    <td class="p-tiny">{{ cashOut.id }}</td>
                    <td class="p-tiny">{{ cashOut.trxDate | dateFormat }}</td>
                    <td class="p-tiny">{{ cashOut.authorisedBy }}</td>
                    <td class="p-tiny">{{ cashOut.trxRef }}</td>
                    <td class="p-tiny">{{ cashOut.name }}</td>
                    <td class="p-tiny">{{ cashOut.memo }}</td>
                    <td class="p-tiny">{{ cashOut.quantity }}</td>
                    <td class="p-tiny">{{ cashOut.userName }}</td>
                    <td class="p-tiny">{{ cashOut.amount | numberFormat }}</td>
                </tr>
                <tr>
                    <th colspan="6"></th>
                    <th>Total</th>
                    <th>{{ total | numberFormat }}</th>
                    <th></th>
                </tr>
            </tbody>
        </table>
    </div>
</template>
